export const MAX_FILE_SIZE = 10_485_760; // 10 Mo

export const formatToMo = (num: number): number => {
  return Math.round(num / 1_048_576);
};
